import React from 'react'
import styles from '../../styles/solution.module.css';

interface SolutionIndustriesCardProps {
    title: string;
    content: string;
    image: string;
    imageWebp: string;
}

const SolutionIndustriesCard: React.FC<SolutionIndustriesCardProps> = ({ title, content, image, imageWebp }) => {
    return (
        <div className={styles.card}>
            <div>
                <img src={image} srcSet={imageWebp} alt={title} loading="lazy" />
            </div>
            <div>
                <span>{title}</span>
                <span>{content}</span>
            </div>
        </div>
    )
}

export default SolutionIndustriesCard;